<h2>Génération d'UML à partir d'une classe JAVA</h2>
<app-input-uml></app-input-uml>
<app-display-uml></app-display-uml>
